var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGranoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "39px",
    viewBox: "0 0 104 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "103.400686 38.6470339 103.400686 0.291564339 0 0.291564339 0 38.6470339 103.400686 38.6470339"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "103.400686 38.6470339 103.400686 0.291564339 0 0.291564339 0 38.6470339 103.400686 38.6470339"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toimiala",
    transform: "translate(-136.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(136.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.008091)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "20.5976303 0.291352425 -0.109657808 4.12669861 -0.109657808 7.96234444 20.5976303 4.12729791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "41.3049257 0.291352425 20.5976303 4.12669861 20.5976303 7.96234444 41.3049257 4.12729791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "62.0122151 0.291352425 41.3049257 4.12669861 41.3049257 7.96234444 62.0122151 4.12729791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "82.7195045 0.291352425 62.0122151 4.12669861 62.0122151 7.96234444 82.7195045 4.12729791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "103.426794 0.291352425 82.7195045 4.12669861 82.7195045 7.96234444 103.426794 4.12729791"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "-0.109657808 34.8110892 -0.109657808 38.6470339 20.5976303 34.8119881 20.5976303 30.975743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "20.5976303 34.8110892 20.5976303 38.6470339 41.3049257 34.8119881 41.3049257 30.975743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "41.3049257 34.8110892 41.3049257 38.6470339 62.0122151 34.8119881 62.0122151 30.975743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "62.0122151 34.8110892 62.0122151 38.6470339 82.7195045 34.8119881 82.7195045 30.975743"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFCC33",
    mask: "url(#mask-4)",
    points: "82.7195045 34.8110892 82.7195045 38.6470339 103.426794 34.8119881 103.426794 30.975743"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.3730337,11.2947743 L31.8819453,9.70964394 C34.3121277,9.26295749 36.0557173,9.66740188 37.3359291,10.665036 C38.5038321,11.5754891 39.3263352,13.1192734 39.3263352,14.9266982 L39.3263352,14.981223 C39.3263352,18.074485 37.7294272,20.2324317 35.1716593,21.5161713 L39.7840439,27.4306705 L34.878863,28.339026 L30.852071,23.037188 L27.5775921,23.6513474 L27.5775921,29.6919734 L23.3730337,30.470007 L23.3730337,11.2947743 Z M31.593923,19.0718195 C33.641677,18.6955364 34.9445952,17.4300697 34.9445952,15.8152826 L34.9445952,15.7604552 C34.9445952,13.953333 33.6885817,13.2217337 31.6411261,13.5980197 L27.5775921,14.3487908 L27.5775921,19.8174995 L31.593923,19.0718195 Z",
    id: "Fill-13",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(42.071006, 8.098716)",
    fill: "#FFCC33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44927633,2.3736248 L12.170963,1.30798451 L19.05369,19.2129559 L14.5877185,20.038026 L13.3071785,16.4471455 L5.90342741,17.8120761 L4.65308308,21.8822991 L0.095987536,22.7262443 L6.44927633,2.3736248 Z M12.0604445,12.8385886 L9.52896348,5.78534881 L7.10656867,13.7568297 L12.0604445,12.8385886 Z",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    points: "22.0846524 3.31014171 26.0083555 2.58453543 34.2896003 12.7451179 34.2896003 1.05213495 38.4980436 0.271695201 38.4980436 19.4493341 34.9167269 20.1126245 26.2927973 9.53471562 26.2927973 21.709735 22.0846524 22.4874719"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.895128, 8.997675)",
    fill: "#FFCC33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.9724676,12.1962588 L82.9724676,12.1414343 C82.9724676,6.69759085 86.2640016,1.68994894 91.9211794,0.608133387 C97.5777306,-0.473391506 101.385813,3.49677447 101.385813,8.94091762 L101.385813,8.9957421 C101.385813,14.4395856 98.0832391,19.2788556 92.4263895,20.3603745 C86.7698085,21.4418934 82.9724676,17.640402 82.9724676,12.1962588 M97.0778912,9.62098566 L97.0778912,9.56735979 C97.0778912,6.35006551 95.1881869,3.84789564 91.9534338,4.60825265 C89.3326489,5.22420998 87.2938461,8.30638782 87.2938461,11.5236791 L87.2938461,11.5776046 C87.2938461,14.7945993 89.1202052,16.9848995 92.303578,16.380326 C94.8201104,15.9024816 97.0318816,12.5764373 97.0778912,9.62098566",
    id: "Fill-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.268382881,12.0423901 L0.268382881,11.9878653 C0.268382881,6.53982664 3.62802452,1.69276568 9.49373125,0.554924038 C12.8249911,-0.0909895751 15.3675031,0.542940922 17.1197754,1.78504077 L14.5933966,5.41576603 C13.1646891,4.45468359 11.8943297,3.98402791 9.75126846,4.38997057 C6.7874944,4.95140306 4.52851113,8.20314843 4.52851113,11.4614862 L4.52851113,11.516011 C4.52851113,15.0203097 6.76120151,17.0563217 10.0422685,16.4349736 C11.5238572,16.1542559 12.8754822,15.4031851 13.8103268,14.4561834 L13.8103268,12.3201083 L9.77756135,13.0657883 L9.77756135,9.31372766 L17.9312296,7.80079862 L17.9312296,15.732135 C16.1398193,17.8700049 13.7849321,19.5650839 10.0709514,20.2607309 C4.30025355,21.3416505 0.268382881,17.709427 0.268382881,12.0423901",
    id: "Fill-21"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGranoLogo);
export default __webpack_public_path__ + "static/media/grano_logo.b6841d254aa3e3f6dcdb256c32f3a658.svg";
export { ForwardRef as ReactComponent };